import { render, staticRenderFns } from "./PicInfoBase.vue?vue&type=template&id=395f37ba&scoped=true&"
import script from "./PicInfoBase.vue?vue&type=script&lang=js&"
export * from "./PicInfoBase.vue?vue&type=script&lang=js&"
import style0 from "./PicInfoBase.vue?vue&type=style&index=0&id=395f37ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f37ba",
  null
  
)

export default component.exports